import React from "react";

import styled from "styled-components";
import { media } from "./_includes/Device";

const Container = styled.div`
  padding: 90px 20px;
  margin: 0 auto;
  max-width: 1200px;
  position: relative;

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    border-bottom: 1px solid #e5e5e5;
    overflow: hidden;
    transition: padding 0.2s ease-in-out;

    &:hover,
    &:focus {
      padding-left: 20px;

      p {
        color: #e1171e;

        &:first-child {
          margin-left: 44px;
        }
      }
    }

    a {
      display: flex;
      padding: 20px 0;
      align-items: center;
      justify-content: space-between;

      span {
        font-weight: 500;
      }
    }

    &:first-child {
      padding-top: 0;
    }
  }

  ${media.tablet`
    display: block;
    padding: 70px 20px;
    
    li {
      &:hover,
      &:focus {
        padding-left: 0;
        
        p {  
          &:first-child {
            margin-left: 0px;
          }
        }
      }
    }
    
    ul li a {
      flex-wrap: wrap;
    
      span {
        width: 40%;
        max-width: 40%;
        flex-basis: 40%;
      }
    }
  `};
`;

const Narrator = styled.span`
  color: #999;
  margin-left: auto;
  font-weight: 300 !important;
`;

export class ArticlesList extends React.Component {
  render() {
    return (
      <div className={this.props.componentClass}>
        <Container>
          {this.props.title && this.props.articles.length > 0 && (
            <h2>{this.props.title}</h2>
          )}

          <ul>
            {this.props.articles &&
              this.props.articles.map((article, index) => {
                if (article.post !== null) {
                  let mediumLink = "";
                  let text = "";
                  let narrator = "";
                  let featuredData = "";

                  if (this.props.isFeatured === true) {
                    featuredData = article.post.document[0].data;
                    text = featuredData.title.text;
                    narrator = featuredData.narrator.text;

                    if (featuredData.medium_url !== null) {
                      mediumLink = featuredData.medium_url.url;
                    }
                  } else {
                    text = article.data.title.text;
                    narrator = article.data.narrator.text;

                    if (article.data.medium_url !== null) {
                      mediumLink = article.data.medium_url.url;
                    }
                  }

                  return (
                    <li key={index}>
                      <a href={mediumLink} target={"_blank"}>
                        <span>{text}</span>
                        <Narrator>{narrator}</Narrator>
                      </a>
                    </li>
                  );
                }

                return "No articles found";
              })}
          </ul>
        </Container>
      </div>
    );
  }
}
